import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/buttons/button.component';
import Dropdown from '../../components/dropdown/dropdown.component';
import Container from '../../components/layout/container.component';
import SvgIcon from '../../components/svg-icon/svg-icon.component';
import { getLogedUser, setUser, updateSelectedDriver } from '../../redux/globals/globals.actions';
import { selectUser } from '../../redux/globals/globals.selectors';
import './Drivers.styles.scss';

const DriversList = () => {
	const user = useSelector(selectUser);
	const [selectedToken, setSelectedToken] = useState();
	const dispatch = useDispatch();
	const [selContract, setSelContract] = useState();

	useEffect(() => {
		//this is not needed anmore
		/* for (let i = 0; i < user.tokens.ownedNfts.length; i++) {
			let tokenId = user.tokens.ownedNfts[i].id.tokenId;
			if (user.driver_contract === user.tokens.ownedNfts[i].contract.address && user.driver_token_id === tokenId) {
				setSelectedToken(user.tokens.ownedNfts[i]);
			}
		} */
	}, []);

	useEffect(() => {
		if (!user) return;

		// Safely parse driver_metadata, handle cases where it might be empty or invalid
		try {
			if (user.driver_metadata) {
				const parsed = typeof user.driver_metadata === 'string' 
					? JSON.parse(user.driver_metadata) 
					: user.driver_metadata;
				if (parsed && typeof parsed === 'object') {
					setSelectedToken(parsed);
				}
			}
		} catch (err) {
			console.warn('Failed to parse driver_metadata:', err);
			setSelectedToken(null);
		}
	}, [user]);

	useEffect(() => {
		(async function () {
			if (selectedToken && selectedToken.id?.tokenId && selectedToken.id.tokenId !== user.driver_token_id) {
				await dispatch(updateSelectedDriver(selectedToken));
				let res = await dispatch(getLogedUser());
				// Handle new response format: {success: true, data: {...}}
				const userData = res.data?.data || res.data;
				await dispatch(setUser(userData));
			}
		})();
	}, [selectedToken]);

	const openSeaLink = (event, link) => {
		event.preventDefault();
		event.stopPropagation();
		window.open(link, '_blank');
	};

	return (
		<Container>
			<div className="driversScreen">
				<div className="selectedDriver">
					<div className="stick">
						<h2 className="mainTitle">Your driver</h2>
						<div className="description">
							This is your ship driver. Your driver will be with you while you fly your ship, he is your avatar.
						</div>

						{user.driver_contract !== '0' && (
							<div className={`driver`}>
								<img src={user?.driver_image?.replaceAll('256', '500')} />

								<div className="details">
									<div className="title">{selectedToken?.title}</div>
									<div className="description">#{parseInt(user?.driver_token_id, 16)}</div>
								</div>
							</div>
						)}

						{user.driver_contract === '0' && (
							<div className="noDriver">
								<div className="title">Hey, you have no available drivers</div>
								<div className="desc">Maybe you should check out one of our supported drivers.</div>
							</div>
						)}
					</div>
				</div>

				<div className="tokensList">
					<div className="upper">
						<div className="main">
							<h2 className="mainTitle">Select your driver</h2>
							<div className="description">
								This is a list of all your available drivers. Your drivers are NFT's you own from the contracts we support. If you
								dont see your NFT listed here, its becuase we didn't add it to our whitelist.
							</div>
						</div>

						<div className="join">
							<h2 className="mainTitle">Every Rocket Needs a driver.</h2>
							<div className="description">
								Pocket Rockets integrates with NFT communities, providing additional utility for their tokens and community
								engagement. Would you like your community to be integrated?
							</div>
							<Button
								title="Reach out"
								onClick={() => {
									window.open('https://discord.gg/pocketrockets', '_blank');
								}}
							/>
						</div>
					</div>

					{!selContract && (
						<div className="contractList">
							{user.tokens.availableContracts.map((item, index) => (
								<div
									key={index}
									className="contract"
									onClick={() => {
										item.userOwns > 0 && setSelContract(item.contract !== -1 ? item.contract : '');
									}}
								>
									<img src={item.image} />

									<div className="details">
										<div className="title">{item.name}</div>
										{item.userOwns > 0 && <div className="owns">You own {item.userOwns} tokens</div>}
										{item.userOwns === 0 && <div className="owns not">You dont own this collection</div>}
									</div>

									{item?.opensea && (
										<div className="link" onClick={(e) => openSeaLink(e, item?.opensea)}>
											<img src="/assets/images/logos/opensea.png" />
										</div>
									)}

									<div className="benefitsOuter">
										<div className="title">Collection perks</div>
										<div className="benefits">
											{item.benefits?.split(',')?.map((item, index) => {
												return (
													<div key={index} className="upgrade">
														{item}
													</div>
												);
											})}
										</div>
									</div>
								</div>
							))}
						</div>
					)}
					{/* <Dropdown allowSelectNone data={user.tokens.availableContracts} dataKey="contract" dataName="name" onChange={onContractChange} /> */}

					{selContract && (
						<div className="driversListOuter">
							<Button
								className="backbutton"
								onClick={() => {
									setSelContract('');
								}}
							>
								<SvgIcon icon="arrow-right" />
								GO BACK
							</Button>

							<div className="driversList">
								{user &&
									user.tokens.ownedNfts
										.filter((item) => {
											return selContract
												? item.contract.address?.toLowerCase() === selContract?.toLowerCase()
												: item.contract.address !== '';
										})
										.map((item, index) => {
											return (
												<div
													key={index}
													onClick={() => {
														setSelectedToken(item);
													}}
													className={`driver ${
														user.driver_contract.toLowerCase() === item.contract.address.toLowerCase() &&
														user?.driver_token_id === item.id.tokenId
															? 'selected'
															: ''
													}`}
												>
													<img
														src={
															item?.media?.[0]?.thumbnail
																? item?.media?.[0]?.thumbnail.replaceAll('256', '500')
																: item?.media?.[0]?.gateway
														}
													/>

													<div className="details">
														<div className="title">{item.title}</div>
													</div>
												</div>
											);
										})}
							</div>
						</div>
					)}
				</div>
			</div>
		</Container>
	);
};

export default DriversList;
